// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResetPassword_reset-password__8MY9p {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_nav__kF-eP {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 15px 0 0 15px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_nav__kF-eP img {
  width: 50px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE {
  padding: 20px 40px;
  width: 500px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_title__0AAsr {
  text-align: center;
  font-size: 26px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-form__OBSKA {
  width: 100%;
  margin: 40px 0 10px 0;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-form__OBSKA .ResetPassword_form-input__Waml5 {
  width: 100%;
  margin-top: 15px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-form__OBSKA .ResetPassword_form-input__Waml5 .ResetPassword_input-title__7F3rw {
  font-size: 14px;
  margin-bottom: 10px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-form__OBSKA .ResetPassword_form-input__Waml5 .ResetPassword_input__Ef0f4 input {
  height: 30px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-status__ytrKP {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: red;
  margin: 5px 0;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-status__ytrKP p {
  margin-left: 5px !important;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_forgot-password__8728s {
  font-size: 14px;
  color: var(--dark-grey);
  cursor: pointer;
  text-decoration: underline;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-button__Rpns1 {
  width: 100%;
  margin: 20px 0 20px 0;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_reset-password-button__Rpns1 button {
  cursor: pointer;
  width: 100%;
  height: 40px;
  background: var(--explore-color);
  color: white;
  border: none;
  border-radius: 10px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs {
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  padding: 10px 40px;
  margin-right: 10px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs svg {
  width: 17px;
  height: 17px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs svg path {
  stroke-width: 0.5px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs .ResetPassword_icon-negative__AbSBu {
  display: block;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs .ResetPassword_icon-with-color__0ovLX {
  display: none;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs:hover {
  cursor: pointer;
  border: 1px solid var(--explore-color);
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs:hover .ResetPassword_icon-negative__AbSBu {
  display: none;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_social-network-login__TEtYJ .ResetPassword_social-network-box__80yZs:hover .ResetPassword_icon-with-color__0ovLX {
  display: block;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_register__LlmZK {
  font-size: 14px;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_reset-password-box__tqtfQ .ResetPassword_box__TWbUE .ResetPassword_register__LlmZK span {
  color: #1677ff;
  text-decoration: underline;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_footer__n0\\+wE {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  padding: 0 20px;
  border-radius: 10px;
  background: #181818;
  color: white;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_footer__n0\\+wE .ResetPassword_privacy-policy__z2axG {
  font-weight: bold;
}
.ResetPassword_reset-password__8MY9p .ResetPassword_footer__n0\\+wE .ResetPassword_privacy-policy__z2axG:hover {
  text-decoration: underline;
  cursor: pointer;
}
@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .ResetPassword_reset-password__8MY9p .ResetPassword_nav__kF-eP {
    justify-content: center;
    padding: 30px 0;
  }
  .ResetPassword_reset-password__8MY9p .ResetPassword_login-box__8UkVi .ResetPassword_box__TWbUE {
    padding: 20px 40px;
    width: 479px;
  }
}
@media only screen and (max-width: 480px) {
  .ResetPassword_reset-password__8MY9p .ResetPassword_nav__kF-eP {
    justify-content: center;
  }
  .ResetPassword_reset-password__8MY9p .ResetPassword_login-box__8UkVi .ResetPassword_box__TWbUE {
    padding: 20px 40px;
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/LandingPage/Pages/ResetPassword/ResetPassword.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;AAEJ;AADI;EACE,WAAA;AAGN;AAAE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;AAGN;AAFM;EACE,kBAAA;EACA,eAAA;AAIR;AAFM;EACE,WAAA;EACA,qBAAA;AAIR;AAHQ;EACE,WAAA;EACA,gBAAA;AAKV;AAJU;EACE,eAAA;EACA,mBAAA;AAMZ;AAHY;EACE,YAAA;AAKd;AAAM;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAER;AADQ;EACE,2BAAA;AAGV;AAAM;EACE,eAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AAER;AAAM;EACE,WAAA;EACA,qBAAA;AAER;AADQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAGV;AAAM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAER;AADQ;EACE,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;AAGV;AAFU;EACE,WAAA;EACA,YAAA;AAIZ;AAHY;EACE,mBAAA;AAKd;AAFU;EACE,cAAA;AAIZ;AAFU;EACE,aAAA;AAIZ;AADQ;EACE,eAAA;EACA,sCAAA;AAGV;AAFU;EACE,aAAA;AAIZ;AAFU;EACE,cAAA;AAIZ;AAAM;EACE,eAAA;AAER;AADQ;EACE,cAAA;EACA,0BAAA;AAGV;AAEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AACI;EACE,iBAAA;AACN;AACI;EACE,0BAAA;EACA,eAAA;AACN;AAEE;EACE;IACE,uBAAA;IACA,eAAA;EAAJ;EAGI;IACE,kBAAA;IACA,YAAA;EADN;AACF;AAIE;EACE;IACE,uBAAA;EAFJ;EAKI;IACE,kBAAA;IACA,UAAA;EAHN;AACF","sourcesContent":[".reset-password {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .nav {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    padding: 15px 0 0 15px;\n    img {\n      width: 50px;\n    }\n  }\n  .reset-password-box {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    .box {\n      padding: 20px 40px;\n      width: 500px;\n      border-radius: 10px;\n      border: 1px solid var(--light-grey);\n      .title {\n        text-align: center;\n        font-size: 26px;\n      }\n      .reset-password-form {\n        width: 100%;\n        margin: 40px 0 10px 0;\n        .form-input {\n          width: 100%;\n          margin-top: 15px;\n          .input-title {\n            font-size: 14px;\n            margin-bottom: 10px;\n          }\n          .input {\n            input {\n              height: 30px;\n            }\n          }\n        }\n      }\n      .reset-password-status {\n        display: flex;\n        align-items: flex-start;\n        font-size: 14px;\n        color: red;\n        margin: 5px 0;\n        p {\n          margin-left: 5px !important;\n        }\n      }\n      .forgot-password {\n        font-size: 14px;\n        color: var(--dark-grey);\n        cursor: pointer;\n        text-decoration: underline;\n      }\n      .reset-password-button {\n        width: 100%;\n        margin: 20px 0 20px 0;\n        button {\n          cursor: pointer;\n          width: 100%;\n          height: 40px;\n          background: var(--explore-color);\n          color: white;\n          border: none;\n          border-radius: 10px;\n        }\n      }\n      .social-network-login {\n        display: flex;\n        justify-content: center;\n        margin-bottom: 20px;\n        .social-network-box {\n          border-radius: 10px;\n          border: 1px solid var(--light-grey);\n          padding: 10px 40px;\n          margin-right: 10px;\n          svg {\n            width: 17px;\n            height: 17px;\n            path {\n              stroke-width: 0.5px;\n            }\n          }\n          .icon-negative {\n            display: block;\n          }\n          .icon-with-color {\n            display: none;\n          }\n        }\n        .social-network-box:hover {\n          cursor: pointer;\n          border: 1px solid var(--explore-color);\n          .icon-negative {\n            display: none;\n          }\n          .icon-with-color {\n            display: block;\n          }\n        }\n      }\n      .register {\n        font-size: 14px;\n        span {\n          color: #1677ff;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n  .footer {\n    width: 100%;\n    height: 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 12px;\n    padding: 0 20px;\n    border-radius: 10px;\n    background: #181818;\n    color: white;\n    .privacy-policy {\n      font-weight: bold;\n    }\n    .privacy-policy:hover {\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n  @media only screen and (min-width: 481px) and (max-width: 1025px) {\n    .nav {\n      justify-content: center;\n      padding: 30px 0;\n    }\n    .login-box {\n      .box {\n        padding: 20px 40px;\n        width: 479px;\n      }\n    }\n  }\n  @media only screen and (max-width: 480px) {\n    .nav {\n      justify-content: center;\n    }\n    .login-box {\n      .box {\n        padding: 20px 40px;\n        width: 95%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reset-password": `ResetPassword_reset-password__8MY9p`,
	"nav": `ResetPassword_nav__kF-eP`,
	"reset-password-box": `ResetPassword_reset-password-box__tqtfQ`,
	"box": `ResetPassword_box__TWbUE`,
	"title": `ResetPassword_title__0AAsr`,
	"reset-password-form": `ResetPassword_reset-password-form__OBSKA`,
	"form-input": `ResetPassword_form-input__Waml5`,
	"input-title": `ResetPassword_input-title__7F3rw`,
	"input": `ResetPassword_input__Ef0f4`,
	"reset-password-status": `ResetPassword_reset-password-status__ytrKP`,
	"forgot-password": `ResetPassword_forgot-password__8728s`,
	"reset-password-button": `ResetPassword_reset-password-button__Rpns1`,
	"social-network-login": `ResetPassword_social-network-login__TEtYJ`,
	"social-network-box": `ResetPassword_social-network-box__80yZs`,
	"icon-negative": `ResetPassword_icon-negative__AbSBu`,
	"icon-with-color": `ResetPassword_icon-with-color__0ovLX`,
	"register": `ResetPassword_register__LlmZK`,
	"footer": `ResetPassword_footer__n0+wE`,
	"privacy-policy": `ResetPassword_privacy-policy__z2axG`,
	"login-box": `ResetPassword_login-box__8UkVi`
};
export default ___CSS_LOADER_EXPORT___;
